import { useState } from "react";
import Calendar from "react-calendar";
import { Card, CardBody, Col } from "reactstrap";
const DatePicker = () => {
  const [dateValue, setDateValue] = useState<Date>(new Date());
  return (
    <Col xl="4" sm="6" className="d-xxl-block d-xl-none box-col-6">
      <Card className="height-equal-2">
        <CardBody>
          <div className="default-datepicker">
            <Calendar onChange={(value)=>setDateValue(value as Date)} value={dateValue} className="w-100" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DatePicker;
